import React from 'react'
import { connect, useDispatch } from 'react-redux'
import { Field, change, formValueSelector } from 'redux-form'
import { Input, Select, Checkbox } from '../../../../../../../../../itrust_common/components/form'

const selector = formValueSelector('VersantClaimForm')
const req = (label) => <>{label} <span className="text-danger">*</span></>
const PREFIX = 'spectacle_lens.frame'
const onlyNumber = (value) => (value == null || value === '' ? value : String(value).replace(/[^\d.-]/g, ''))
const FRAME_TYPES = [
  { name: '1/2 Eye Metal', value: '1/2 Eye Metal' },
  { name: '1/2 Eye Zyl', value: '1/2 Eye Zyl' },
  { name: 'Drilled Rimless', value: 'Drilled Rimless' },
  { name: 'Grooved Rimless', value: 'Grooved Rimless' },
  { name: 'Industrial Drill', value: 'Industrial Drill' },
  { name: 'Industrial Edge', value: 'Industrial Edge' },
  { name: 'Industrial Groove', value: 'Industrial Groove' },
  { name: 'Industrial Metal', value: 'Industrial Metal' },
  { name: 'Metal Edge', value: 'Metal Edge' },
  { name: 'Zyl Edge', value: 'Zyl Edge' },
]
const THICKNESS_TYPES = [
  { name: 'Lab Decide Best Thickness', value: 'Lab Decide Best Thickness' },
  { name: 'Edge Thickness', value: 'Edge Thickness' },
  { name: 'Center Thickness', value: 'Center Thickness' },
  { name: 'Thickness at Drilling Point', value: 'Thickness at Drilling Point' },
]

function VersantFrameInformationFields({ thicknessType }) {
  const dispatch = useDispatch()
  const showThickness = thicknessType && thicknessType !== 'Lab Decide Best Thickness'

  return (
    <div className="border rounded p-5 mb-6">
      <h6 className="mb-5">Frame Information</h6>
      <Field name={`${PREFIX}.frame_not_in_catalog`} component={Checkbox} label="Frame not in the Catalog" wrapperClasses="mb-5" />
      <div className="row">
        <Field name={`${PREFIX}.manufacturer`} component={Input} label={req('Manufacturer')} placeholder="Enter Manufacturer" className="form-control" wrapperClasses="col-3 form-group" />
        <Field name={`${PREFIX}.brand`} component={Input} label="Brand" placeholder="Enter Brand" className="form-control" wrapperClasses="col-3 form-group" />
        <Field name={`${PREFIX}.model`} component={Input} label={req('Model')} placeholder="Enter Model" className="form-control" wrapperClasses="col-3 form-group" />
        <Field name={`${PREFIX}.color`} component={Input} label={req('Color')} placeholder="Enter Color" className="form-control" wrapperClasses="col-3 form-group" />
        <Field name={`${PREFIX}.eye_size`} component={Input} label={req('Eye Size')} placeholder="Enter EyeSize" className="form-control" wrapperClasses="col-3 form-group" normalize={onlyNumber} />
        <Field name={`${PREFIX}.temple_lenght`} component={Input} label={req('Temple Length')} placeholder="Enter TempleLength" className="form-control" wrapperClasses="col-3 form-group" normalize={onlyNumber} />
        <Field name={`${PREFIX}.frame_type`} component={Select} label={req('Frame Type')} data={FRAME_TYPES} textField="name" valueField="value" placeholder="Select One" wrapperClasses="col-3 form-group" />
        <Field name={`${PREFIX}.thickenss_type`} component={Select} label={req('Thickness Type')} data={THICKNESS_TYPES} textField="name" valueField="value" placeholder="Select One" wrapperClasses="col-3 form-group" />
        {showThickness && (
          <>
            <Field name={`${PREFIX}.left_thickness`} component={Input} label="Left Thickness" placeholder="mm" className="form-control" wrapperClasses="col-3 form-group" normalize={onlyNumber} />
            <Field name={`${PREFIX}.right_thickness`} component={Input} label="Right Thickness" placeholder="mm" className="form-control" wrapperClasses="col-3 form-group" normalize={onlyNumber} />
          </>
        )}
      </div>
      <button type="button" className="btn btn-link p-0 mb-3" onClick={() => ['a_box', 'b_box', 'dbl', 'ed'].forEach((field) => dispatch(change('VersantClaimForm', `${PREFIX}.${field}`, '')))}>
        Reset (ABox, BBox, DBL and ED)
      </button>
      <div className="border rounded p-5">
        <div className="row">
          {[['a_box', 'A Box'], ['b_box', 'B Box'], ['dbl', 'DBL'], ['ed', 'ED']].map(([name, label]) => (
            <Field key={name} name={`${PREFIX}.${name}`} component={Input} label={req(label)} placeholder="mm" className="form-control" wrapperClasses="col-3 form-group mb-0" normalize={onlyNumber} />
          ))}
        </div>
      </div>
    </div>
  )
}

export default connect((state) => ({
  thicknessType: selector(state, `${PREFIX}.thickenss_type`),
}))(VersantFrameInformationFields)
